import React from 'react';
import IconAsBtn from '@tekion/tekion-components/src/atoms/iconAsBtn/IconAsBtn';
import styles from './Favourites.module.scss';
const Favourites = _ref => {
  let {
    isSelected = false,
    onClick
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.favIcon
  }, /*#__PURE__*/React.createElement(IconAsBtn, {
    onClick: onClick
  }, isSelected ? 'icon-star-filled' : 'icon-star'));
};
export default Favourites;